define.alias("ember-power-select/helpers/ember-power-select-is-equal", "calendar/helpers/ember-power-select-is-equal");